import { useEffect } from 'react';
import { listenClients } from '../../channels/clientsChannel';
import { useClientsStore } from '../../stores/useClientsStore';
import { useScreenStore } from '../../stores/useScreenStore';

export function useClientsChannel() {

    useEffect(() => {

        const unsubscribe = listenClients(({ tipo, payload }) => {

            const {screen} = useScreenStore.getState();

            const {
                setClientes,
                upsertCliente,
                removeCliente,
                setClientesSelecionados
            } = useClientsStore.getState();

            if(screen === 'Filtros'){

                if (tipo === 'clientes-sync') {

                    setClientes(payload, false);

                }

                if (tipo === 'cliente-upsert') {

                    upsertCliente(payload, false);

                }

                if (tipo === 'cliente-remove') {

                    removeCliente(payload, false);

                }

            }

            if(screen === 'Home'){

                if (tipo === 'clientes-selected') {
                    setClientesSelecionados(payload, false);
                }

            }

        });

        return unsubscribe;

    }, []);

}